import { useMemo } from 'react';
import { I18n } from 'react-redux-i18n';
import PrescriptionType from '../enum/prescription';

export const usePrescription = (prescriptionType) => {

  return useMemo(() => {
    switch (prescriptionType) {
      case PrescriptionType.MELATONIN:
        return {
          title: I18n.t('COMPONENTS.PRESCRIPTION.PRESCRIPTION_FEEDBACK.TITLES.MELATONIN'),
          classTitle: 'MELATONIN',
          colorIcon: '#8371B9',
          url: 'https://themens.com.br/comprar/1010465921-1'
        };
      case PrescriptionType.ERECTILY_DYSFUNCTION:
        return {
          title: I18n.t('COMPONENTS.PRESCRIPTION.PRESCRIPTION_FEEDBACK.TITLES.ED'),
          classTitle: 'ED',
          colorIcon: '#4C9C9C',
          url: 'https://themens.com.br/comprar/1023402213-1'
        };
      case PrescriptionType.HAIR_LOSS:
        return {
          title: I18n.t('COMPONENTS.PRESCRIPTION.PRESCRIPTION_FEEDBACK.TITLES.HAIR_LOSS'),
          classTitle: 'HAIR_LOSS',
          colorIcon: '#6DA7CB',
          url: 'https://themens.com.br/comprar/1286126329-1,1023380956-1,1023393219-1,1010424294-1',
        };
      case PrescriptionType.PRECOCIOUS:
        return {
          title: I18n.t('COMPONENTS.PRESCRIPTION.PRESCRIPTION_FEEDBACK.TITLES.PRECOCIOUS'),
          classTitle: 'PRECOCIOUS',
          colorIcon: '#4C9C9C',
          url: 'https://themens.com.br/checkout/v3/start/1767307220/99a9831a76ca38bc59ea52681a089e1322725f45?from_store=1&country=BR'
        };
      case PrescriptionType.WEIGHT_LOSS:
        return {
          title: I18n.t('COMPONENTS.PRESCRIPTION.PRESCRIPTION_FEEDBACK.TITLES.WL'),
          classTitle: 'WL',
          colorIcon: '#4C9C9C',
          url: 'https://theladies.com.br/indicacaomedica'
        };
      default:
        return {
          title: '',
          classTitle: '',
          colorIcon: '#1D6EA3',
          url: '',
        };
    }
  }, [ prescriptionType ]);
};